import '@expo/metro-runtime';
import React, { lazy, Suspense } from 'react';
import LandscapeOverlay from '@photosi/rn-components/landscape-overlay/LandscapeOverlay';
import useIsOrientationLocked from 'src/hooks/use-is-orientation-locked/useIsOrientationLocked';
import Scaffold from '@photosi/rn-components/scaffold/Scaffold';
import { usePreventPageZoom } from 'src/hooks/usePreventPageZoom';
import { TRouteComponent } from './_shared/routes.types';
import { GoogleOneTapLogin } from '@photosi/rn-components/google-one-tap-login/GoogleOneTapLogin';

const EditorApp = lazy(() => import('src/screen/editor/EditorApp'));

export const EditorRoute: TRouteComponent = () => {
  const showOverlay = useIsOrientationLocked();

  usePreventPageZoom();

  return (
    <Suspense fallback={<Scaffold showHeader={false} showLoader={true} />}>
      {showOverlay && <LandscapeOverlay />}
      <EditorApp />
      <GoogleOneTapLogin />
    </Suspense>
  );
};
